import CryptoJS from 'crypto-js'
function uuid() {
  const s = []
  const hexDigits = '0123456789abcashdsah12ddsajdk12du9usaioowjdfdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}

function uuidWithoutHyphen() {
  return CryptoJS.MD5(uuid().replace(/-/g, '') + Date.now()).toString()
}

function randomString(length = 32) {
  const chars = '0123456789abcdef'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}

function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export {
  uuid,
  uuidWithoutHyphen,
  randomString,
  randomNumber
}